import type { Module } from 'vuex';
import { ExchangeCurrency } from '@/types/ExchangeCurrency';
import {RootState} from "@/store";

export interface ExchangeCurrenciesState {
  exchangeCurrencies: ExchangeCurrency[];
}

const exchangeCurrenciesModule: Module<ExchangeCurrenciesState, RootState> = {
  namespaced: true,
  state: () => ({
    exchangeCurrencies: [],
  }),
  mutations: {
    setExchangeCurrencies(state, payload: { exchangeCurrencies: Record<number, any> | any[] }) {
      const exchangeCurrencies = Array.isArray(payload.exchangeCurrencies)
        ? payload.exchangeCurrencies
        : Object.values(payload.exchangeCurrencies);
      state.exchangeCurrencies = exchangeCurrencies.map(raw => ExchangeCurrency.fromRaw(raw));
    },
    addExchangeCurrency(state, payload: any) {
      state.exchangeCurrencies.push(ExchangeCurrency.fromRaw(payload));
    },
    deleteExchangeCurrency(state, payload: { idExchangeCurrency: number }) {
      state.exchangeCurrencies = state.exchangeCurrencies.filter(
        exchangeCurrency => exchangeCurrency.idExchangeCurrency !== payload.idExchangeCurrency
      );
    },
    lockExchangeCurrency(state, payload: { idExchangeCurrency: number }) {
      const exchangeCurrency = state.exchangeCurrencies.find(exchangeCurrency => exchangeCurrency.idExchangeCurrency === payload.idExchangeCurrency);
      if (exchangeCurrency) exchangeCurrency.locked = true;
    },
    unlockExchangeCurrency(state, payload: { idExchangeCurrency: number }) {
      const exchangeCurrency = state.exchangeCurrencies.find(exchangeCurrency => exchangeCurrency.idExchangeCurrency === payload.idExchangeCurrency);
      if (exchangeCurrency) exchangeCurrency.locked = false;
    },
  },
  actions: {
    wsSetExchangeCurrencies({ commit }, payload) {
      commit('setExchangeCurrencies', payload);
    },
    wsExchangeCurrenciesAdd({ commit }, payload) {
      commit('addExchangeCurrency', payload);
    },
    wsExchangeCurrenciesDelete({ commit }, payload) {
      commit('deleteExchangeCurrency', payload);
    },
    wsExchangeCurrenciesLock({ commit }, payload) {
      commit('lockExchangeCurrency', payload);
    },
    wsExchangeCurrenciesUnlock({ commit }, payload) {
      commit('unlockExchangeCurrency', payload);
    },
  },
};

export default exchangeCurrenciesModule; 